export default "__VITE_ASSET__a9dd40f3__"